(function($) {
  'use strict';

  // Logo switching functionality - only active when sticky header is enabled
  function initLogoSwitching() {
    var $header = $('.page-header--sticky');
    var $logoDefault = $('.logo-default');
    var $logoScrolled = $('.logo-scrolled');
    var scrollThreshold = 50;
    
    // Only proceed if sticky header is enabled and both logos exist
    if ($header.length && $logoDefault.length && $logoScrolled.length) {
      
      function handleLogoSwitch() {
        var scrollTop = $(window).scrollTop();
        
        if (scrollTop > scrollThreshold) {
          // When scrolled: show black logo (default), hide white logo (scrolled)
          $logoDefault.removeClass('logo-hidden');
          $logoScrolled.removeClass('logo-visible');
        } else {
          // When at top: show white logo (scrolled), hide black logo (default)
          $logoDefault.addClass('logo-hidden');
          $logoScrolled.addClass('logo-visible');
        }
      }
      
      // Initial check
      handleLogoSwitch();
      
      // Bind scroll event for logo switching
      $(window).on('throttled-scroll.logoSwitch', handleLogoSwitch);
    }
  }

  // Initialize when DOM is ready
  $(document).ready(function() {
    initLogoSwitching();
  });

  // Re-initialize when sections are loaded (for Shopify section editor)
  $(document).on('shopify:section:load', function() {
    initLogoSwitching();
  });

})(theme.jQuery); 